@if (inProgressIconVisible) {
  <div
    class="spinner-border save-status-content"
    [class.new-design]="newDesign"
    [krosTooltip]="savingTooltip"
    position="below"
  ></div>
}

@if (savedIconVisible) {
  <div
    class="save-status-content"
    [class.save-status-flex]="newDesign"
    [krosTooltip]="savedTooltip"
    position="below"
  >
    @if (newDesign) {
      <i class="hgi hgi-18 hgi-stroke hgi-checkmark-circle-02"></i>
    } @else {
      <i class="material-icons success">done</i>
    }
  </div>
}
